module.exports = __webpack_public_path__ + "static/image-3-e32e47743a44a4d670a2e397b2c74dda.jpg";